import { render, staticRenderFns } from "./level_three.vue?vue&type=template&id=2ba1d256&scoped=true&"
import script from "./level_three.vue?vue&type=script&lang=js&"
export * from "./level_three.vue?vue&type=script&lang=js&"
import style0 from "./level_three.vue?vue&type=style&index=0&id=2ba1d256&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1d256",
  null
  
)

export default component.exports